<template>
<div>
  <heading :class="{'is-compact': isCompact}">{{ title }}</heading>
  <text-block class="text-block" v-if="description">{{ description }}</text-block>
  <slot></slot>
</div>
</template>

<script>
import Heading from '@/components/general/heading'
import TextBlock from '@/components/general/text-block'
export default {
  components: {
    Heading,
    TextBlock
  },
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false
    },
    isCompact: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    uppercased (value) {
      if (!value) { return '' }
      value = value.toString()
      return value.toUpperCase()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

h6.heading {
  margin-bottom: 0.5rem;
  &.is-compact {
    margin-bottom: 0.5rem;
  }
}

p {
  color: $black;
}

</style>



// WEBPACK FOOTER //
// src/components/general/sidebar-section.vue